import { UploadFileInterface } from '../document/interface';
import { FolderTree } from './interface';

export type SelectPermissionType = {
  action: string;
  label: string;
};
export const SELECT_PERMISSIONS: SelectPermissionType[] = [
  {
    action: '',
    label: 'No Access',
  },
  {
    action: 'doc_free',
    label: 'See',
  },
  {
    action: 'doc_protect',
    label: 'See;Protected',
  },
  {
    action: 'doc_protect_without_print',
    label: 'See;Protected;No Print',
  },
];

export const getPermissionLabel = (action = '') => {
  const item = SELECT_PERMISSIONS.find((item) => item.action === action) || { label: 'No Access' };
  return item.label;
};

export const getPermissionLevel = (action = '') => SELECT_PERMISSIONS.findIndex((item) => item.action === action);

// 将上传文件列表，转为树状结构，
export function generateFolderTree(uploadFiles: UploadFileInterface[]) {
  const newTree: FolderTree[] = [];

  uploadFiles.forEach((uploadFile) => {
    const { file_path: filePath = '', name: fileName, id = '', folderId, policies } = uploadFile;
    const pathArrs = filePath.split('/');
    const entries = pathArrs.entries();
    // 注意这里的主要是用了指针去赋值
    const poll = (tableData: FolderTree[], parentPath: string) => {
      const { done, value } = entries.next();
      if (done) return; // 没有就接触
      const [index, name] = value;
      const findIndex = tableData.findIndex((item) => item.name === name);
      const path = parentPath === '/' ? `/${name}` : `${parentPath}/${name}`;

      if (findIndex < 0) {
        const dataItem: FolderTree = {
          id: `${index}_${name}`,
          folderId,
          name,
          level: index,
          type: 'folder',
          expand: true,
          children: [],
          path,
          parentPath,
        };
        if (name === fileName) {
          dataItem.id = id;
          dataItem.type = 'file';
          if (policies) {
            policies.forEach((item) => {
              dataItem[item.group_id] = { action: item.action };
            });
          }
        }
        poll(dataItem.children, path);
        if (dataItem.type === 'folder') {
          tableData.push(dataItem);
        } else {
          tableData.push(dataItem);
        }
      } else {
        const dataItem = tableData[findIndex];
        poll(dataItem.children, path);
        // eslint-disable-next-line no-param-reassign
        tableData[findIndex] = dataItem;
      }
    };
    poll(newTree, '/');
  });
  const treeTraverseSort = (treeNode: any) => {
    if (treeNode[0]?.children?.length) {
      treeNode[0].children.sort((param1: any, param2: any) => -param1.name.localeCompare(param2.name));
      if (treeNode[0]?.children?.length > 1) {
        treeNode[0].children.forEach((child: any) => {
          treeTraverseSort(child);
        });
      }
      treeTraverseSort(treeNode[0].children);
    } else if (treeNode?.children?.length) {
      treeNode.children.sort((param1: any, param2: any) => -param1.name.localeCompare(param2.name));
      if (treeNode?.children?.length > 1) {
        treeNode.children.forEach((child: any) => {
          treeTraverseSort(child);
        });
      }
      treeTraverseSort(treeNode.children);
    }
  };
  treeTraverseSort(newTree);
  return newTree;
}
